<template>
	<div class="d-flex">
		<v-menu :model-value="datePickerOpen" :close-on-content-click="false"
			@update:modelValue="open => $emit('datePickerClicked', open)">
			<template v-slot:activator="{ props }">
				<v-text-field v-bind="props"
					:model-value="selectedDateTime.format('YYYY-MM-DD')"
					:disabled="loading"
					append-inner-icon="mdi-calendar"
					variant="outlined"
					density="compact"
					flat
					single-line
					hide-details
					width="105"
				/>
			</template>
			<v-date-picker :model-value="selectedDateTime"
				hide-header
				border="sm"
				elevation="6"
				show-adjacent-months
				weeks-in-month="dynamic"
				@update:month="month => $emit('onUpdateMonth', month)"
				@update:year="year => $emit('onUpdateYear', year)">
				<template v-slot:day="{ props, item}">
					<v-btn v-bind="props"
						variant="outlined"
						:color="getDayColor(item)"
						@click="$emit('onDayClicked', item.date)">
						{{ item.localized }}
					</v-btn>
				</template>
			</v-date-picker>
		</v-menu>
		<v-menu :model-value="timePickerOpen" :close-on-content-click="false"
			@update:modelValue="open => $emit('timePickerClicked', open)">
			<template v-slot:activator="{ props }">
				<v-text-field v-bind="props"
					:model-value="selectedDateTime.format('H:mm')"
					class="ml-1"
					:disabled="loading"
					append-inner-icon="mdi-clock-time-four-outline"
					variant="outlined"
					density="compact"
					width="75"
					flat
					single-line
					hide-details
					readonly
				/>
			</template>
			<v-time-picker :model-value="selectedDateTime.format('HH:mm')"
				hide-header
				format="24hr"
				border="sm"
				color="secondary"
				elevation="6"
				:allowed-minutes="[0]"
				@update:modelValue="time => $emit('onTimeClicked', time)">
			</v-time-picker>
		</v-menu>
	</div>
</template>

<script>
import * as _ from "lodash";
import moment from "moment-timezone";

export default {
	name: "PlaylistDateTimePicker",

	emits: ["datePickerClicked", "onUpdateMonth", "onUpdateYear", "onDayClicked", "timePickerClicked", "onTimeClicked"],

	props: ["selectedStationID", "datePickerOpen", "selectedDateTime", "timezone", "loading", "timePickerOpen"],

	methods: {
		getDayColor({date}) {
			// We use the isoDate because of misbehavior regarding the date property
			const from = moment.tz(date.format("YYYY-MM-DD"), this.stationTimezone);
			const to = from.clone().endOf("day");

			const playlistsByDay = this.$store.getters.loadedPlaylistsNoAssetsByDate(this.selectedStationID, from);
			if (_.isUndefined(playlistsByDay)) {
				return "black";
			}

			let playlists = 0;
			while (from.isSameOrBefore(to)) {
				const hourPlaylist = playlistsByDay.find(
					(p) => from.isSame(p.ScheduledStartDateTime, "hour")
				);
				from.add(1, "hour");
				if (!hourPlaylist) {
					continue;
				}
				playlists++;
			}

			return playlists === 24 ? "green" : playlists === 0 ? "red" : "orange";
		},

		setHourColor() {
			document.querySelectorAll(".v-time-picker-clock__item span").forEach(el => {
				const date = this.selectedDateTime.clone().hour(el.innerHTML);
				const playlistsByDay = this.$store.getters.loadedPlaylistsNoAssetsByDate(this.selectedStationID, date);
				if (!_.isUndefined(playlistsByDay)) {
					const playlistExists = playlistsByDay.some(
						(p) => date.isSame(p.ScheduledStartDateTime, "hour")
					);

					el.parentElement.classList.add(playlistExists ? "with-playlist" : "empty");
				}
			});
		}
	},

	watch: {
		timePickerOpen(open) {
			if (open) {
				this.$nextTick(this.setHourColor);
			}
		},

		selectedDateTime() {
			this.$nextTick(this.setHourColor);
		}
	}
};
</script>

<style scoped lang="scss">
:deep(.v-date-picker-month) {
	.v-date-picker-month__day {
		.v-btn {
			&:hover {
				border-width: 2px;
			}
		}

		&.v-date-picker-month__day--selected .v-btn {
			background-color: $ihm-blue;
			color: $ihm-white !important;
		}
	}
}

:deep(.v-time-picker) {
	.v-time-picker-clock {
		margin: 12px;
	}

	.v-time-picker-clock__item {
		height: 33px;
		width: 33px;

		&.with-playlist {
			border: 1px solid $ihm-green--dark;
		}

		&.empty {
			border: 1px solid $ihm-red-error;
		}

		&:hover {
			border-width: 2px;
		}
	}
}
</style>